<template>
  <v-container>
    <v-layout>
      <v-flex class=primary xs12>
        12
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  

  export default {
    
  }
</script>
